import React from 'react'
import MyLibTypes from './MyLibTypes';
class MyUI extends React.Component {    
  render(){
    const {type} = this.props;
    // console.warn("render MyUI:",this.props,type,MyUITypes.Types);
    if(type && MyLibTypes.Types[type]){
      return MyLibTypes.Types[type](this.props);
    }
    console.warn("MyLib no type",this.props);
    return (
      <div></div>
    )
  } 
}

export default MyUI